import { render } from "./confirmReserveComponent.vue?vue&type=template&id=2e4d5622&scoped=true"
import script from "./confirmReserveComponent.vue?vue&type=script&lang=js"
export * from "./confirmReserveComponent.vue?vue&type=script&lang=js"

import "./confirmReserveComponent.vue?vue&type=style&index=0&id=2e4d5622&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4d5622"]])

export default __exports__